import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/ArrowBendUpRight.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...e, weights: a }));
r.displayName = "ArrowBendUpRightIcon";
const p = r;
export {
  p as ArrowBendUpRight,
  r as ArrowBendUpRightIcon
};
